// pages/ForgotPasswordPage.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Mail, CheckCircle, XCircle, ArrowLeft } from 'lucide-react';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const API_URL = process.env.REACT_APP_API_URL || '/api';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!email) {
      setError('Veuillez saisir votre email');
      return;
    }

    setLoading(true);
    try {
      // ✅ Route corrigée
      const res = await axios.post(`${API_URL}/forgot-password`, { email });
      if (res.data.success) {
        setMessage(res.data.message);
        setEmail('');
      } else {
        setError(res.data.message);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur lors de la demande');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white rounded-xl border border-gray-200 shadow-xl p-8 w-full max-w-md">
        <div className="text-center mb-6">
          <Mail className="w-12 h-12 text-emerald-600 mx-auto mb-3" />
          <h2 className="text-2xl font-bold text-emerald-700">Mot de passe oublié</h2>
          <p className="text-sm text-gray-500 mt-1">
            Saisissez votre email pour recevoir un nouveau mot de passe.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">📧 Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full p-2 border rounded-lg focus:ring-2 focus:ring-emerald-500" placeholder="prenom.nom@entreprise.com" required />
          </div>

          {error && <div className="flex items-center gap-2 text-red-500 text-sm bg-red-50 p-2 rounded"><XCircle size={16} /> {error}</div>}
          {message && <div className="flex items-center gap-2 text-green-500 text-sm bg-green-50 p-2 rounded"><CheckCircle size={16} /> {message}</div>}

          <button type="submit" disabled={loading}
            className="w-full bg-emerald-600 text-white py-2 rounded-lg hover:bg-emerald-700 transition disabled:opacity-50">
            {loading ? 'Envoi...' : 'Recevoir un nouveau mot de passe'}
          </button>

          <button type="button" onClick={() => navigate('/')}
            className="w-full text-sm text-gray-500 hover:text-emerald-600 flex items-center justify-center gap-1 mt-2">
            <ArrowLeft size={14} /> Retour à la connexion
          </button>
        </form>
      </div>
    </div>
  );
}